(function ($) {
  saProductV1 = {
    formatter: $('.sa-product-v1'),
    quickshopSelector: '#quickshop'
  };

  Drupal.behaviors.saProductV1 = {
    get: function (key) {
      return saProductV1[key];
    },

    set: function (key, val) {
      saProductV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');
      var $qs = $();

      formatter.once('sa-product-v1-init-processed').each(function () {
        var thisFormatter = $(this);
        var hotspots = thisFormatter.parents('.hotspots');
        var prodId = thisFormatter.attr('data-productid');
        var qs_style = thisFormatter.attr('data-qs-style') ? thisFormatter.attr('data-qs-style') : '';
        var skuids = thisFormatter.attr('data-skus') ? thisFormatter.attr('data-skus') : '';
        var product = $(page_data['product-input-type'].products).filter(function () {
          return this.PRODUCT_ID === prodId;
        })[0];

        if (product && !product.skus) {
          product.skus = page_data['product-input-type'].skus.filter(function (p) {
            if (thisFormatter.data('formattedPrice') && product['GIFTSET_COMPONENTS']) {
              p.formattedPrice = thisFormatter.data('formattedPrice');
            }

            return p.PRODUCT_ID === prodId;
          });
        } else {
          product.skus = product.skus.filter(function (p) {
            if (thisFormatter.data('formattedPrice') && product['GIFTSET_COMPONENTS']) {
              p.formattedPrice = thisFormatter.data('formattedPrice');
            }

            return p;
          });
        }

        thisFormatter.find('.marker').on('click', function() {
          hotspots.find('.marker').not($(this)).removeClass('open');
          $qs = thisFormatter.find('.js-quickshop--shoppable-ad');
          var useLoaded = $qs.find('.js-sells-with').length || false;

          hotspots.find('.module-spp-detail').not($qs).fadeTo(750, 0, function () {
            $(this).hide();
          });

          if ($qs.length && !$(this).hasClass('open') && useLoaded) {
            // we don't need to load the sells with everytime, so just show the loaded content
            // if there is any available
            self.showLoadedQuickshop($(this), $qs);
            jQuery(window).trigger('Home:productQV', [product]);

            return true;
          }

          if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $qs.fadeTo(750, 0, function () {
              $(this).hide();
            });
          } else {
            $(this).addClass('open');
            // blow away old shoppable ad quickshop (if present)
            thisFormatter.find(self.get('quickshopSelector')).remove();
            $qs = site.shopTheAd.render({
              productData: product,
              skuids: skuids
            });
            $('.prod-hd', $qs).html(thisFormatter.attr('data-header'));
            if ($('.prod-hd', $qs).find('span').css('color')) {
              $('.btn-add-to-bag', $qs).css('background', $('.prod-hd', $qs).find('span').css('color'));
            }
            thisFormatter.attr('data-qs-top') ? $qs.css('top', thisFormatter.attr('data-qs-top')) : '';
            thisFormatter.attr('data-qs-right') ? $qs.css('right', thisFormatter.attr('data-qs-right')) : '';
            $qs.appendTo(thisFormatter); // even if there was a quickshop DOM node already present, this just adds it right back to where it was
            $qs.css({
              display: 'block',
              opacity: '0'
            }).fadeTo(750, 1, function () {
              var sellsWithData = $qs.find('[data-sells-with]');

              if (sellsWithData.length) {
                $(document).trigger('sells_with_init', $qs);
              }
            });
          }
          // Omniture tagging
          jQuery(window).trigger('Home:productQV', [product]);
          // console.log("QV product data",[product]);
        });
      });
      $(document).on('qs-overlay-close', function (e, args) {
        args.quickshop.fadeTo(750, 0, function () {
          $(this).hide();
        });
        args.quickshop.closest('.js-sa-product').find('.marker').removeClass('open');
      });
    },

    showLoadedQuickshop: function ($hotspot, $qs) {
      if ($qs.length && !$hotspot.hasClass('open')) {
        $hotspot.addClass('open');
        $qs.css({
          display: 'block',
          opacity: '0'
        }).fadeTo(750, 1);
        // have to overwrite the click event when we reuse the html
        // the initialy set gets' messed up ubon opening another fresh qs
        $qs.find('.close').off('click').on('click', function(e) {
          e.preventDefault();
          $(document).trigger('qs-overlay-close', [{ quickshop: $qs }]);
        });
      }
    }
  };
})(jQuery);
